export const validateABN = (value: string | undefined) => {
  const weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
  if (value === undefined) return false;
  const abn = value.replace(/[^\d]/g, '');
  let isValidABNFormat = false;

  // check length is 11 digits
  if (abn.length === 11) {
    // apply ato check method
    let sum = 0;
    let weight;

    for (let index: number = 0; index <= weights.length - 1; index += 1) {
      weight = weights[index];
      const digit = Number(abn[index]) - (index ? 0 : 1);
      sum += weight * digit;
    }

    isValidABNFormat = sum % 89 === 0;
  }

  return isValidABNFormat;
};
